import React, { FC, useState } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { PaddedPaper } from 'components';
import { ClientDepartmentFragment, ClientLocationFragment } from 'api';

import { ClearFiltersButton } from '../shared';
import { UserSearchesV2Filter } from './type';
import Chips from './Chips';
import Filters from './Filters';
import { TabValues } from 'features/admin/containers/UserManagement';

interface Props {
  filter: UserSearchesV2Filter;
  tab: TabValues;
  setFilter: (filter: UserSearchesV2Filter) => void;
  clearFilter: () => void;
  hasFilters: boolean;
}

const FilterBar: FC<Props> = ({ filter, tab, setFilter, clearFilter, hasFilters }) => {
  const [selectedDepartments, setSelectedDepartments] = useState<Array<ClientDepartmentFragment>>(
    []
  );
  const [selectedLocations, setSelectedLocations] = useState<Array<ClientLocationFragment>>([]);

  return (
    <PaddedPaper>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid>
          <Filters
            filter={filter}
            tab={tab}
            setFilter={setFilter}
            clearFilter={clearFilter}
            setSelectedDepartments={setSelectedDepartments}
            setSelectedLocations={setSelectedLocations}
          />
        </Grid>
        {hasFilters && tab !== TabValues.ExpressActivated && (
          <Grid>
            <ClearFiltersButton onClick={clearFilter} />
          </Grid>
        )}
      </Grid>
      <Chips
        filter={filter}
        tab={tab}
        setFilter={setFilter}
        isEmpty={!hasFilters}
        selectedDepartments={selectedDepartments}
        selectedLocations={selectedLocations}
      />
    </PaddedPaper>
  );
};

export default FilterBar;
